import { render } from "./SideBarNavProposal.vue?vue&type=template&id=aa96f5b6&ts=true"
import script from "./SideBarNavProposal.vue?vue&type=script&lang=ts"
export * from "./SideBarNavProposal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__